import { useTheme } from '@emotion/react';

import * as styles from './pagination.styles';

type Props = {
  pageNumber: number;
  currentPage: number;
  onPageChange: (page: number) => void;
};

export const PaginationPageButton = ({ pageNumber, currentPage, onPageChange }: Props) => {
  const theme = useTheme();

  return (
    <button
      css={[
        styles.item(theme),
        styles.itemClickable(theme),
        currentPage === pageNumber && styles.active(theme),
      ]}
      data-testid="pagination-page-button"
      onClick={() => onPageChange(pageNumber)}>
      {pageNumber}
    </button>
  );
};
